import { render, staticRenderFns } from "./downloadIssueReport.vue?vue&type=template&id=8b9a8a52&scoped=true"
import script from "./downloadIssueReport.vue?vue&type=script&lang=js"
export * from "./downloadIssueReport.vue?vue&type=script&lang=js"
import style0 from "./downloadIssueReport.vue?vue&type=style&index=0&id=8b9a8a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9a8a52",
  null
  
)

export default component.exports